import Manager from "../Manager";

export default class Field {

  el = null
  config = {}
  form = null

  constructor(form, el, config) {
    this.form = form;
    this.el = el;
    this.config = config;
    this.validateField = this.validateField.bind(this);
    this.clearError = this.clearError.bind(this);
    this.applyConfig();
    this.bindClearErrorOnChange()
    if (!config.disablePrecognition){
      this.bindPrecognitionEvent()
    }
    this.dispatchEvent('init')
  }

  getContainer(){
    return this.getElementsAsArray()[0].closest('.Form__group');
  }

  getLabel(){
    return this.getContainer().querySelector('label')
  }

  getForm(){
    return this.form;
  }

  getRawFieldName(){
    return this.getElementsAsArray()[0].name
  }

  getFieldName(){
    return this.getRawFieldName().replaceAll('[]', '')
  }

  getValue(){
    if (this.el.value !== '') return this.el.value;
    return undefined;
  }

  getError(){
    return this.getContainer().querySelector('span.--error');
  }

  getElementsAsArray(){
    return Array.isArray(this.el) ? this.el : [this.el];
  }

  enable(){
    for (let el of this.getElementsAsArray()) el.disabled = false;
  }

  disable(){
    for (let el of this.getElementsAsArray()) el.disabled = true;
  }

  applyConfig() {
    if ('events' in this.config ){
      for (let eventName of Object.keys(this.config.events)){
        for (let el of this.getElementsAsArray()){
          el.addEventListener(eventName, (event) => {
            const _event = {
              event,
              detail: {
                field: this
              }
            }
            this.config.events[eventName](_event)
          })
        }
      }
    }
  }


  bindPrecognitionEvent() {
    for (let el of this.getElementsAsArray()){
      el.addEventListener('change', this.validateField)
    }
  }

  bindClearErrorOnChange(){
    for (let el of this.getElementsAsArray()){
      el.addEventListener('keyup', this.clearError)
      el.addEventListener('focus', this.clearError)
    }
  }

  validateField(e){

    this.form.clearOutput()

    /*
    * Add a small timeout to prevent submit button instant disabling
    * */
    setTimeout(() => {
      this.clearError()
      this.disable();
      this.form.setLoading(true);
      const url = this.getForm().getFormElement().action;

      const formData  = new FormData();
      if (this.getValue() !== undefined){
        if (Array.isArray(this.getValue())){
          for (let value of this.getValue()) formData.append(this.getRawFieldName(), value)
        } else {
          formData.append(this.getFieldName(), this.getValue())
        }
      }

      const xhr = new XMLHttpRequest();
      xhr.open('POST', url, true);
      xhr.setRequestHeader('X-Dry-Run', this.getFieldName());
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.onreadystatechange = () => {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          this.enable();
          this.form.setLoading(false);

          switch (xhr.status) {
            case 422:
              const json = JSON.parse(xhr.responseText);
              const errors = Object.values(json);
              if (errors.length){
                if (Array.isArray(errors[0])) this.displayError(errors[0][0])
                else this.displayError(errors[0])

                this.dispatchEvent('precognitionFailed', {errors:json})
                this.form.dispatchEvent('precognitionFailed', {field: this, errors:json})

              }
              break;
            case 200:
              this.dispatchEvent('precognitionSuccess')
              this.form.dispatchEvent('precognitionSuccess', {field: this})
              break;
          }
        }
      }
      xhr.send(formData);
    }, 200)
  }

  displayError(text){
    let error = this.getError();
    if (!error){
      error = document.createElement('span');
      error.classList.add('--error');
      this.getContainer().appendChild(error);
      this.getContainer().classList.add('--error');
    }
    error.innerHTML = this.executeHook('errorText', text);
  }

  clearError(){
    this.getContainer().classList.remove('--error');
    const error = this.getError();
    if (error){
      error.remove()
    }
  }

  dispatchEvent(name, data={}){
    Manager.log(`Triggering event [${name}] on field: `, this)

    data.field = this;

    this.getElementsAsArray().forEach(function (el, elIndex) {
      const event = new CustomEvent(name, {
        detail: {
          ...data,
          el,
          elIndex
        }
      });
      el.dispatchEvent(event);
    });
  }

  executeHook(name, data){
    if ('hooks' in this.config){
      if (name in this.config.hooks){
        Manager.log(`Executing hook [${name}] on field: `, this)
        data = this.config.hooks[name](data)
      }
    }
    return data;
  }

  destroy(){
    /* Remove custom events */
    if ('events' in this.config ){
      for (let eventName of Object.keys(this.config.events)){
        for (let el of this.getElementsAsArray()){
          el.removeEventListener(eventName, this.config.events[eventName])
        }
      }
    }
  }

}
